import { css } from '@emotion/react'

export const globalStyles = css`
  html,
  body {
    overflow-x: hidden;
  }
`
